
import * as React from "react"
import { createRoot } from "react-dom/client"

import "./tailwind.css"
import "../../node_modules/font-awesome/css/font-awesome.css"

export class Reset extends React.Component<{}, {
    strength?: number
    , firstName?: string
    , lastName?: string
    , empNo?: string
    , safessn?: string
    , email?: string
}>{


    constructor(props, context) {
        super(props);

        this.state = {

        }
    }

    validEmail(email: string) {
        if (!email || !email.length)
            return false;

        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
        return re.test(email)
    }

    firstNameChanged(e: React.SyntheticEvent<any>) {
        this.setState({ firstName: (e.target as HTMLInputElement).value as string });
    }

    lastNameChanged(e: React.SyntheticEvent<any>) {
        this.setState({ lastName: (e.target as HTMLInputElement).value as string });
    }

    empNoChanged(e: React.SyntheticEvent<any>) {
        this.setState({ empNo: (e.target as HTMLInputElement).value as string });
    }

    ssnChanged(e: React.SyntheticEvent<any>) {
        this.setState({ safessn: (e.target as HTMLInputElement).value as string });
    }

    emailChanged(e: React.SyntheticEvent<any>) {
        this.setState({ email: (e.target as HTMLInputElement).value as string });
    }


    render() {

        var submitDisabled = true;
        if (this.state.firstName && this.state.firstName.length > 0 &&
            this.state.lastName && this.state.lastName.length > 0 &&
            this.state.empNo && this.state.empNo.length > 0 &&
            this.state.safessn && this.state.safessn.length == 4 &&
            this.state.email && this.validEmail(this.state.email))
            submitDisabled = false;

        return <fieldset className="flex flex-col gap-2 text-sm">
            <div className="flex">
                <label className="font-bold w-36">First Name: </label>

                <input onChange={(e) => this.firstNameChanged(e)} className="rom-inp w-44 border border-1 border-green-700" value={this.state.firstName}  name="FirstName" />

            </div>
            <div className="flex">

                <label className="font-bold w-36" >Last Name: </label>

                <input onChange={(e) => this.lastNameChanged(e)} className="rom-inp w-44 border border-1 border-green-700" value={this.state.lastName}  name="LastName" />

            </div>
            <div className="flex">  
                <label className="font-bold w-36">Employee #: </label>

                <input onChange={(e) => this.empNoChanged(e)} className="rom-inp w-44 border border-1 border-green-700" value={this.state.empNo}  name="EmployeeNum" />
            </div>
            <div className="flex">

                <label  className="font-bold w-36">Last 4 Digits SSN: </label>

                <input onChange={(e) => this.ssnChanged(e)} className="rom-inp w-44 border border-1 border-green-700" value={this.state.safessn}  name="LastFourSSN" />

            </div>
            <div className="flex"> 

                <label  className="font-bold w-36">EMail: </label>

                <input onChange={(e) => this.emailChanged(e)} value={this.state.email} className="rom-inp w-44 border border-1 border-green-700"  name="EMail" />
            </div>


            <button disabled={submitDisabled} className="rom-btn" type="submit" >Submit</button>
        </fieldset>

    }
}



createRoot(document.getElementById("reset")).render(<Reset />);




